<template>
  <v-footer absolute>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }} DevKor</div>
  </v-footer>
</template>

<script>
export default {
  name: 'footer'
}
</script>